import { createSlice } from "@reduxjs/toolkit";

const staffSlice = createSlice({
    name: 'staff',
    initialState: {
        loading: false,
        staffList: [],
        staff: {},
        isStaffCreated: false,
        isStaffUpdated: false,
        isStaffDeleted: false
    },
    reducers: {
        staffRequest(state) {
            return { ...state, loading: true };
        },
        staffListSuccess(state, action) {
            return { ...state, loading: false, staffList: action.payload.staff };
        },
        singleStaffSuccess(state, action) {
            return { ...state, loading: false, staff: action.payload.staff };
        },
        newStaffSuccess(state, action) {
            return { ...state, loading: false, staff: action.payload.staff, isStaffCreated: true };
        },
        clearStaffCreated(state) {
            return { ...state, isStaffCreated: false };
        },
        updateStaffSuccess(state, action) {
            return { ...state, loading: false, staff: action.payload.staff, isStaffUpdated: true };
        },
        clearStaffUpdated(state) {
            return { ...state, isStaffUpdated: false };
        },
        deleteStaffSuccess(state) {
            return { ...state, loading: false, isStaffDeleted: true };
        },
        clearStaffDeleted(state) {
            return { ...state, isStaffDeleted: false };
        },
        staffFail(state, action) {
            return { ...state, loading: false, error: action.payload };
        },
        clearStaffError(state) {
            return { ...state, error: null };
        }
    }
});

const { actions, reducer } = staffSlice;

export const {
    staffRequest,
    staffListSuccess,
    singleStaffSuccess,
    newStaffSuccess,
    clearStaffCreated,
    updateStaffSuccess,
    clearStaffUpdated,
    deleteStaffSuccess,
    clearStaffDeleted,
    staffFail,
    clearStaffError
} = actions;

export default reducer;
